/**
 * The `deliveryOfService` (Leistungszeitraum) missing-field is a *per-invoice*
 * field — it is set in the invoice settings on the invoice page, NOT in the
 * organisation settings. When it is the only missing precondition, the error
 * must be shown with per-invoice wording instead of the generic "configure in
 * the organisation settings" message.
 *
 * This helper is shared by every component that surfaces the
 * `E_INVOICE_PRECONDITIONS_NOT_MET` error (`OpenInvoiceButton`,
 * `InvoiceSubHeader`, `InvoiceDocumentDisplay`) so the wording stays
 * consistent.
 */
/** The single per-invoice missing-field identifier (the Leistungszeitraum). */
export const DELIVERY_OF_SERVICE_FIELD = "deliveryOfService";

export const isServicePeriodOnlyMissing = (
  fields: readonly string[] | null | undefined
): boolean => fields?.length === 1 && fields[0] === DELIVERY_OF_SERVICE_FIELD;

/**
 * Split a preconditions `missingFields` list into the per-invoice service
 * period and the genuine organisation-level fields, so the two can be presented
 * with the correct wording even when they are missing together.
 * `deliveryOfService` is set on the invoice, NOT in the organisation settings,
 * and must never be listed among "organisation fields".
 */
export const splitMissingFields = (
  fields: readonly string[] | null | undefined
): { servicePeriodMissing: boolean; orgFields: string[] } => {
  const list = fields ?? [];
  return {
    servicePeriodMissing: list.includes(DELIVERY_OF_SERVICE_FIELD),
    orgFields: list.filter(f => f !== DELIVERY_OF_SERVICE_FIELD),
  };
};

/** Tolgee key (namespace `"Invoices"`) for the per-invoice service-period message. */
export const SERVICE_PERIOD_MISSING_KEY =
  "Service period is missing — please set it on the invoice.";
